module.exports = __webpack_public_path__ + "img/0fd3416c.83180f47.jpeg";